export default "__VITE_ASSET__COk1f18z__"